import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'apps/website/src/environments/environment';
import { catchError, Observable, throwError } from 'rxjs';
import { CommonWebService } from '../common-services';

@Injectable({
  providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(
    private commonWebService: CommonWebService,
    private router: Router
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const API_URL = `${environment.baseUrl}${req.url}`;
    return next
      .handle(
        req.clone({
          url: API_URL,
        })
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errMessage: any;
          let customMessage: string = 'Please try again later...';
          if (error.error instanceof ErrorEvent) {
            errMessage = `${error.error.message ? error.error.message : customMessage}`;
          } else if (error.error?.message) {
            errMessage = `${error.error.message ? error.error.message : customMessage}`;
            if (error.status) {
              switch (error.status) {
                case 401: {
                  this.router.navigate(['/error', 401]);
                  break;
                }
                case 501: {
                  this.router.navigate(['/error', 501]);
                  break;
                }
                case 500: {
                  this.router.navigate(['/error', 500]);
                  break;
                }
                case 301: {
                  this.router.navigate(['/error', 301]);
                  break;
                }
                case 403: {
                  this.router.navigate(['/error', 403]);
                  break;
                }
              }
            }
          }
          return throwError(() => errMessage);
        })
      )
  }
}
